// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!./node_modules/vue-style-loader!./node_modules/css-loader??ref--10-2!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/lib??ref--10-3!./node_modules/sass-loader/lib/loader.js??ref--10-4!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=style&index=2&id=7dcad0e4&prod&lang=scss&
// module id = MzC0
// module chunks = 1